<template>
<div>
    <div class="cont_list">
        <ul class="title">
            <h1 class="apply_title"> 신청자 리스트</h1>
            <p class="apply_sub_txt">신청 받은 학습자 리스트를 확인하실 수 있습니다.</p>
        </ul>
        <ul class="apply_check">
            <li>
                <select name="SField" id="select">
                    <option value="name">이름</option>
                    <option value="email">이메일</option>
                </select>
                <input type="text" name="SText" id="textfield" class="input_text" style="width:200px; margin-left:10px;" />
                <a href="javascript:fnc_send();"><span class="btn_page_btn">Search</span></a>
            </li>
            <li style="float:right;">
                <a href="javascript:fnc_past_apply_input()"><span class="btn_page_btn">수강자등록</span></a>
            </li>
        </ul>
        <ul>
            <li>
                <table width="1100" border="0" cellspacing="0" cellpadding="0" class="row_table">
                    <tr>
                        <td width="45" class="title"></td>
                        <td width="45" class="title">no</td>
                        <td class="title">서비스코드</td>
                        <td class="title">서비스명</td>
                        <td class="title">이름</td>
                        <td class="title">사번</td>
                        <td class="title">이메일</td>
                        <td width="130" class="title">신청일</td>
                    </tr>
                    <tr>
                        <td><input type="checkbox" name="ckb[]" value="30"></td>
                        <td>77</td>
                        <td>2678</td>
                        <td>2월17일 월요일(영어)12:40~13:00</td>
                        <td>나호준</td>
                        <td>06378194</td>
                        <td></td>
                        <td>2020-02-04 23:03:00</td>
                    </tr>
                    <tr class='tr02'>
                        <td><input type="checkbox" name="ckb[]" value="29"></td>
                        <td>76</td>
                        <td>2678</td>
                        <td>2월11일 화요일(중국어)12:40~13:00</td>
                        <td>장미나</td>
                        <td>14024341</td>
                        <td></td>
                        <td>2020-01-31 10:06:00</td>
                    </tr>
                    <tr>
                        <td><input type="checkbox" name="ckb[]" value="28"></td>
                        <td>75</td>
                        <td>2678</td>
                        <td>2월10일 월요일(영어)12:00~12:20</td>
                        <td>김수성</td>
                        <td>08080099</td>
                        <td></td>
                        <td>2020-01-31 16:49:00</td>
                    </tr>
                    <tr class='tr02'>
                        <td><input type="checkbox" name="ckb[]" value="27"></td>
                        <td>74</td>
                        <td>2678</td>
                        <td>2월20일 목요일(중국어)12:20~12:40</td>
                        <td>김수현</td>
                        <td>11227104</td>
                        <td></td>
                        <td>2020-02-04 18:04:00</td>
                    </tr>
                    <tr>
                        <td><input type="checkbox" name="ckb[]" value="26"></td>
                        <td>73</td>
                        <td>2678</td>
                        <td>2월10일 월요일(영어)12:40~13:00</td>
                        <td>이재은</td>
                        <td>08040491</td>
                        <td></td>
                        <td>2020-01-31 22:19:00</td>
                    </tr>
                    <tr class='tr02'>
                        <td><input type="checkbox" name="ckb[]" value="25"></td>
                        <td>72</td>
                        <td>2678</td>
                        <td>2월13일 목요일(중국어)17:20~17:40</td>
                        <td>이권기</td>
                        <td>88701864</td>
                        <td></td>
                        <td>2020-01-31 23:51:00</td>
                    </tr>
                    <tr>
                        <td><input type="checkbox" name="ckb[]" value="24"></td>
                        <td>71</td>
                        <td>2678</td>
                        <td>2월14일 금요일(영어)12:00~12:30</td>
                        <td>현세희</td>
                        <td>15014274</td>
                        <td></td>
                        <td>2020-02-01 02:43:00</td>
                    </tr>
                    <tr class='tr02'>
                        <td><input type="checkbox" name="ckb[]" value="23"></td>
                        <td>70</td>
                        <td>2678</td>
                        <td>2월18일 화요일(중국어)17:20~17:40</td>
                        <td>홍종옥</td>
                        <td>01030291</td>
                        <td></td>
                        <td>2020-02-04 18:00:00</td>
                    </tr>
                    <tr>
                        <td><input type="checkbox" name="ckb[]" value="22"></td>
                        <td>69</td>
                        <td>2678</td>
                        <td>2월19일 수요일(영어)18:00~18:20</td>
                        <td>오두철</td>
                        <td>96053224</td>
                        <td></td>
                        <td>2020-02-05 02:30:00</td>
                    </tr>
                    <tr class='tr02'>
                        <td><input type="checkbox" name="ckb[]" value="21"></td>
                        <td>68</td>
                        <td>2678</td>
                        <td>2월12일 수요일(영어)15:00~15:20</td>
                        <td>민경석</td>
                        <td>13073308</td>
                        <td></td>
                        <td>2020-01-29 19:32:00</td>
                    </tr>
                    <tr>
                        <td><input type="checkbox" name="ckb[]" value="20"></td>
                        <td>67</td>
                        <td>2726</td>
                        <td>영어 / 3월27일(금요일) 원어민 1:1 수업 / 15:20~15:40</td>
                        <td>김범진</td>
                        <td>20200330</td>
                        <td>ciankim@carrotglobal.com</td>
                        <td>2020-03-24 21:16:00</td>
                    </tr>
                    <tr class='tr02'>
                        <td><input type="checkbox" name="ckb[]" value="19"></td>
                        <td>66</td>
                        <td>2726</td>
                        <td>OPIc 1등급 (삼성등급) 대비반</td>
                        <td>정태호</td>
                        <td>17066352</td>
                        <td></td>
                        <td>2020-02-18 18:02:00</td>
                    </tr>
                    <tr>
                        <td><input type="checkbox" name="ckb[]" value="18"></td>
                        <td>65</td>
                        <td>2726</td>
                        <td>OPIc 1등급 (삼성등급) 대비반</td>
                        <td>조용연</td>
                        <td>08038957</td>
                        <td></td>
                        <td>2020-02-18 18:30:00</td>
                    </tr>
                    <tr class='tr02'>
                        <td><input type="checkbox" name="ckb[]" value="17"></td>
                        <td>64</td>
                        <td>2726</td>
                        <td>TSC 4등급 (삼성등급) 대비반</td>
                        <td>이명우</td>
                        <td>12215111</td>
                        <td></td>
                        <td>2020-02-18 20:07:00</td>
                    </tr>
                    <tr>
                        <td><input type="checkbox" name="ckb[]" value="16"></td>
                        <td>63</td>
                        <td>2726</td>
                        <td>TSC 4등급 (삼성등급) 대비반</td>
                        <td>이선호</td>
                        <td>10098712</td>
                        <td></td>
                        <td>2020-02-18 20:17:00</td>
                    </tr>
                    <tr class='tr02'>
                        <td><input type="checkbox" name="ckb[]" value="15"></td>
                        <td>62</td>
                        <td>2726</td>
                        <td>OPIc 1등급 (삼성등급) 대비반</td>
                        <td>배은경</td>
                        <td>12243413</td>
                        <td></td>
                        <td>2020-02-19 00:30:00</td>
                    </tr>
                    <tr>
                        <td><input type="checkbox" name="ckb[]" value="14"></td>
                        <td>61</td>
                        <td>2726</td>
                        <td>OPIc 1등급 (삼성등급) 대비반</td>
                        <td>유명상</td>
                        <td>18040954</td>
                        <td></td>
                        <td>2020-02-19 19:00:00</td>
                    </tr>
                    <tr class='tr02'>
                        <td><input type="checkbox" name="ckb[]" value="13"></td>
                        <td>60</td>
                        <td>2726</td>
                        <td>TSC 4등급 (삼성등급) 대비반</td>
                        <td>서동원</td>
                        <td>00120058</td>
                        <td></td>
                        <td>2020-02-19 22:29:00</td>
                    </tr>
                    <tr>
                        <td><input type="checkbox" name="ckb[]" value="12"></td>
                        <td>59</td>
                        <td>2726</td>
                        <td>TSC 4등급 (삼성등급) 대비반</td>
                        <td>장경호</td>
                        <td>03043489</td>
                        <td></td>
                        <td>2020-02-21 17:46:00</td>
                    </tr>
                    <tr class='tr02'>
                        <td><input type="checkbox" name="ckb[]" value="11"></td>
                        <td>58</td>
                        <td>2726</td>
                        <td>OPIc 1등급 (삼성등급) 대비반</td>
                        <td>최성욱</td>
                        <td>18022554</td>
                        <td></td>
                        <td>2020-02-21 17:48:00</td>
                    </tr>
                    <tr>
                        <td><input type="checkbox" name="ckb[]" value="10"></td>
                        <td>57</td>
                        <td>2726</td>
                        <td>TSC 4등급 (삼성등급) 대비반</td>
                        <td>윤종규</td>
                        <td>02064202</td>
                        <td></td>
                        <td>2020-02-21 17:53:00</td>
                    </tr>
                    <tr class='tr02'>
                        <td><input type="checkbox" name="ckb[]" value="9"></td>
                        <td>56</td>
                        <td>2726</td>
                        <td>TSC 4등급 (삼성등급) 대비반</td>
                        <td>송운한</td>
                        <td>00147002</td>
                        <td></td>
                        <td>2020-02-21 17:59:00</td>
                    </tr>
                    <tr>
                        <td><input type="checkbox" name="ckb[]" value="8"></td>
                        <td>55</td>
                        <td>2726</td>
                        <td>OPIc 1등급 (삼성등급) 대비반</td>
                        <td>류연희</td>
                        <td>18014283</td>
                        <td></td>
                        <td>2020-02-21 18:15:00</td>
                    </tr>
                    <tr class='tr02'>
                        <td><input type="checkbox" name="ckb[]" value="7"></td>
                        <td>54</td>
                        <td>2726</td>
                        <td>OPIc 1등급 (삼성등급) 대비반</td>
                        <td>장승보</td>
                        <td>17104926</td>
                        <td></td>
                        <td>2020-02-21 18:46:00</td>
                    </tr>
                    <tr>
                        <td><input type="checkbox" name="ckb[]" value="6"></td>
                        <td>53</td>
                        <td>2726</td>
                        <td>OPIc 1등급 (삼성등급) 대비반</td>
                        <td>김세라</td>
                        <td>04073421</td>
                        <td></td>
                        <td>2020-02-21 18:50:00</td>
                    </tr>
                    <tr class='tr02'>
                        <td><input type="checkbox" name="ckb[]" value="5"></td>
                        <td>52</td>
                        <td>2726</td>
                        <td>OPIc 1등급 (삼성등급) 대비반</td>
                        <td>장준호</td>
                        <td>14057682</td>
                        <td></td>
                        <td>2020-02-21 22:54:00</td>
                    </tr>
                    <tr>
                        <td><input type="checkbox" name="ckb[]" value="4"></td>
                        <td>51</td>
                        <td>2726</td>
                        <td>TSC 4등급 (삼성등급) 대비반</td>
                        <td>서한힘</td>
                        <td>18048776</td>
                        <td></td>
                        <td>2020-02-21 23:29:00</td>
                    </tr>
                    <tr class='tr02'>
                        <td><input type="checkbox" name="ckb[]" value="3"></td>
                        <td>50</td>
                        <td>2726</td>
                        <td>OPIc 1등급 (삼성등급) 대비반</td>
                        <td>허동녕</td>
                        <td>18014976</td>
                        <td></td>
                        <td>2020-02-21 23:39:00</td>
                    </tr>
                    <tr>
                        <td><input type="checkbox" name="ckb[]" value="2"></td>
                        <td>49</td>
                        <td>2726</td>
                        <td>TSC 4등급 (삼성등급) 대비반</td>
                        <td>김기곤</td>
                        <td>03095496</td>
                        <td></td>
                        <td>2020-02-22 02:58:00</td>
                    </tr>
                    <tr class='tr02'>
                        <td><input type="checkbox" name="ckb[]" value="1"></td>
                        <td>48</td>
                        <td>2678</td>
                        <td>영어 / 3월27일(금요일) 원어민 1:1 수업 / 15:20~15:40</td>
                        <td>김범진</td>
                        <td>20200330</td>
                        <td></td>
                        <td>2020-03-24 21:16:00</td>
                    </tr>

                </table>
            </li>
        </ul>
        <ul>
            <li>
                <table border=0 width=100%>
                    <tr>
                        <td height=10></td>
                    </tr>
                    <tr>
                        <td align=center>
                            <img src='/_admin/global_edu/images/btn_pre02.jpg' border=0 align=absmiddle> <img src='/_admin/global_edu/images/btn_pre.jpg' border=0 align=absmiddle> &nbsp; <span class='text12num'>&nbsp;<b>1</b>&nbsp;</span> &nbsp;<a href="?GotoPage=2&seq=&SField=&SText=">2</a>&nbsp;&nbsp;<a href="?GotoPage=3&seq=&SField=&SText=">3</a>&nbsp; &nbsp;<font color=#95918C><img src='/_admin/global_edu/images/btn_next.jpg' border=0 align=absmiddle></font> <a href="?GotoPage=3&seq=&SField=&SText="><img src=/_admin/global_edu/images/btn_next02.jpg border=0 align=absmiddle></a>
                        </td>
                    </tr>
                </table>
            </li>
        </ul>
    </div>

</div>
</template>

<script>
export default {

}
</script>
